import { cmsGraphql } from '../../../lib/cms/index.js'

export const headerNavbarFragment = cmsGraphql(/* GraphQL */ `
  fragment headerNavbarFragment on CmsHeader_Nav {
    type
    title
    submenu {
      categories {
        name
        items {
          title
          description
          link {
            ...listItemLinkFragment
          }
        }
      }
    }
    link {
      ...listItemLinkFragment
      ...resolveHrefFragment
    }
  }
`)
